import React, { useEffect } from "react";
import "../styles/Registration.css";
import { Link } from "react-router-dom";
import result from "../assets/result.png";
import result_mobile from "../assets/result_mobile.png";
import { useNavigate } from "react-router-dom";

function Registration() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to /results on component mount
    navigate("/results");
  }, [navigate]);
  
  return (
    <div className="registration-ru">
      <h1>ПОБЕДИТЕЛИ OPEN QUALS</h1>
      <div className="registration-form-container">
        <div className="registration-text">
          По результатам Отборочного этапа стали известны команды-полуфиналисты,
          которые сразятся на очных этапах за звание победителей Кубка CTF
          России.
        </div>
        <div className="result">
          <img src={result} />
        </div>
        <div className="result_mobile">
          <img src={result_mobile} />
        </div>
      </div>
    </div>
  );
}

export default Registration;
